<script>
import { debounce } from 'throttle-debounce'
export default {
  name: 'SuiButton',
  inject: {
    SuiForm: {
      default: null
    }
  },
  props: {
    // 按钮类型
    type: {
      type: String,
      default: 'primary',
      validator(value) {
        return ['primary', 'success', 'warning', 'danger', 'info', 'text'].indexOf(value) !== -1
      }
    },
    // 按钮尺寸
    size: {
      type: String,
      default: null,
      validator(value) {
        return ['medium', 'small', 'mini'].indexOf(value) !== -1
      }
    },
    plain: {
      type: Boolean
    },
    round: {
      type: Boolean
    },
    circle: {
      type: Boolean
    },
    icon: {
      type: String,
      default: ''
    },
    iconFloat: {
      type: String,
      default: 'left',
      validator(value) {
        return ['left', 'right'].indexOf(value) !== -1
      }
    },
    color: {
      type: String,
      default: ''
    },
    width: {
      type: [Number, String],
      default: null
    },
    disabled: {
      type: Boolean
    },
    visible: {
      type: Boolean,
      default: true
    },
    loading: {
      type: Boolean
    },
    autofocus: {
      type: Boolean
    },
    nativeType: {
      type: String,
      default: 'button',
      validator(value) {
        return ['button', 'submit', 'reset'].indexOf(value) !== -1
      }
    },
    // 按钮文字
    text: {
      type: String,
      default: ''
    },
    // 标签提示内容
    tip: {
      type: [String, Boolean],
      default: null
    },
    // 按钮关联的数据，表格行编辑时，需要传递行数据
    data: {
      type: Object,
      default: null
    },
    stopClick: {
      type: Boolean,
      default: true
    },
    // 节流的最小时间间隔（毫秒）
    wait: {
      type: [Number, String],
      default: 500
    },
    // 防抖的最小时间间隔（毫秒）
    debounce: {
      type: [Number, String],
      default: 500
    }
  },
  data() {
    return {
      lastCallTime: null,
      debounceWrapper: null
    }
  },
  computed: {
    elMode() {
      return (this.$ELEMENT || {}).$mode || 'easy'
    },
    elSize() {
      if (this.$options.propsData.size === undefined && this.SuiForm) {
        return this.SuiForm.size || (this.$ELEMENT || {}).size
      }
      return this.size || (this.$ELEMENT || {}).size
    },
    elDisabled() {
      if (this.$options.propsData.disabled === undefined && this.SuiForm) {
        return this.SuiForm.disabled
      }
      return this.disabled
    },
    elWidth() {
      return this.repairPx(this.width)
    }
    // _textNode () {
    //   if (this.$scopedSlots.default) {
    //     return this.$scopedSlots.default();
    //   } else {
    //     return this._locale(this.text);
    //   }
    // },
  },
  mounted() {
    this.handleTestId()
  },
  methods: {
    handleTestId() {
      if (this.$attrs['is-test'] === true && this.buttonEl) {
        if (this.$attrs['test-id']) {
          this.buttonEl.elm.dataset['testId'] = this.$attrs['test-id']
        } else if (this.$attrs.key || this.$attrs.prop) {
          this.buttonEl.elm.dataset['testId'] = this.$attrs.key || this.$attrs.prop
        } else if (this.$options.parent.prop) {
          if (this.$options.parent.prop.key) {
            this.buttonEl.elm.dataset['testId'] = this.$options.parent.prop.key
          }
        }
      }
    },
    // 点击事件
    handleClick(event) {
      if (this.stopClick) {
        event.stopPropagation()
      }
      let fn = () => {
        const auth = this.$attrs['auth'] || this.$attrs['permissionId'] || ''
        localStorage.setItem('__BUTTON_AUTH__', auth)
        this.$emit('click', this.data, event, this)
      }
      if (!this.debounceWrapper) {
        this.debounceWrapper = debounce(Number(this.debounce), true, () => {
          fn()
        })
      }
      // 节流和防抖互斥
      if (this.debounce) {
        this.debounceWrapper()
      } else {
        if (!this.lastCallTime) {
          this.lastCallTime = new Date().getTime()
          fn()
        } else {
          let now = new Date().getTime()
          if (now - this.lastCallTime >= Number(this.wait)) {
            this.lastCallTime = new Date().getTime()
            fn()
          }
        }
      }
    },
    getText() {
      let text
      if (this.$scopedSlots.default) {
        text = this.$scopedSlots.default()
      } else {
        text = this._locale(this.text)
      }
      return typeof text === 'string' ? text : text[0].text
    },
    // 构造按钮
    createButton(h) {
      let obj = {}
      obj.class = [
        'sui-button',
        'el-button',
        this.type ? 'el-button--' + this.type : 'el-button--default',
        this.elSize ? 'el-button--' + this.elSize : '',
        'sui-button--' + this.elMode,
        {
          'is-disabled': this.elDisabled,
          'is-loading': this.loading,
          'is-plain': this.plain,
          'is-round': this.round,
          'is-circle': this.circle,
          'is-hide': !this.visible
        }
      ]
      obj.style = {
        width: this.elWidth,
        color: this.type === 'text' ? this.color : ''
      }
      obj.attrs = {
        type: this.nativeType,
        autofocus: this.autofocus,
        disabled: this.disabled
      }
      obj.on = {
        click: this.handleClick
      }
      let content = []
      let text = this.getText()
      text && content.push(text)
      if (this.icon || this.loading) {
        let icon = this.loading ? 'el-icon-loading' : this.icon
        let iconEl = h('i', {
          class: [icon, text && this.iconFloat ? 'btn-icon-' + this.iconFloat : '']
        })
        if (this.iconFloat === 'left') {
          content.unshift(iconEl)
        } else {
          content.push(iconEl)
        }
      }
      return h('button', obj, content)
    },
    // 处理提示
    createButtonTip(h) {
      if (this.tip) {
        let text = this.getText()
        let content = this.tip === true ? text : this._locale(this.tip)
        this.buttonEl = h(
          'sui-tooltip',
          {
            attrs: {
              content
            }
          },
          [this.buttonEl]
        )
      }
    }
  },
  render(h) {
    const auth = this.$attrs['auth']
    if (auth && this.$permission && !this.$permission.isAuth(auth)) {
      return ''
    }
    const permissionId = this.$attrs['permissionId']
    if (permissionId && this.$permission && !this.$permission.isAuth(permissionId)) {
      return ''
    }
    this.buttonEl = this.createButton(h)
    this.createButtonTip(h)
    return this.buttonEl
  }
}
</script>
<style lang="scss"></style>



// WEBPACK FOOTER //
// src/components/SimbartUI/components/basic/SuiButton.vue